import { marked } from 'marked';

// 将 markdown 文本转换为安全 HTML，并做额外包装
export const parseMarkdown = (content = '') => {
    let html = marked.parse(content);
    
    // 处理特殊的下载链接格式：ApiCallGet:/api/...（忽略大小写）
    // 将其转换为带有特殊属性的链接，便于后续处理
    html = html.replace(
        /<a\s+href="apicallget:(\/[^"]+)"/gi,
        (match, apiPath) => {
            // 提取 uuid 参数
            const uuidMatch = apiPath.match(/uuid=([^&\s]+)/);
            const uuid = uuidMatch ? uuidMatch[1] : '';
            
            // 返回带有特殊属性的链接
            return `<a href="#" data-download-api="${apiPath}" data-download-uuid="${uuid}" class="download-link"`;
        }
    );
    
    // 为所有普通链接添加 target/_blank + rel
    html = html.replace(/<a\s+(?!.*class="download-link")href="http/gi, '<a target="_blank" rel="noopener noreferrer" href="http');

    // 包裹 table，便于样式控制
    html = html.replace(/<table[\s\S]*?<\/table>/gi, (match) => {
        return `<div class="answer-text-table">${match}</div>`;
    });

    return html;
};

// 检查链接是否为下载链接
export const isDownloadLink = (element) => {
    return element && element.classList && element.classList.contains('download-link');
};

// 从下载链接元素中提取参数
export const extractDownloadParams = (element) => {
    if (!isDownloadLink(element)) {
        return null;
    }
    
    const apiPath = element.getAttribute('data-download-api');
    const uuid = element.getAttribute('data-download-uuid');
    
    if (!apiPath || !uuid) {
        return null;
    }
    
    return {
        apiPath,
        uuid,
    };
};

